import React from 'react';
import SettingsContext from './SettingsContext';

export const useSettings = () => {
  return React.useContext(SettingsContext);
};
